import { render, staticRenderFns } from "./HoldOrNot.vue?vue&type=template&id=39a4253e&scoped=true"
import script from "./HoldOrNot.vue?vue&type=script&lang=js"
export * from "./HoldOrNot.vue?vue&type=script&lang=js"
import style0 from "./HoldOrNot.vue?vue&type=style&index=0&id=39a4253e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a4253e",
  null
  
)

export default component.exports